import { useSelector } from "react-redux";
import useGetInvestorOverviewSummary from "../../../../hooks/useGetInvestorOverviewSummary";
import { toast } from "react-toastify";
import { formatNumbersWithThousandSeperators } from "@funded-here-interface/common/src/Utils/formatter";

const GraphAmountSec = () => {
  const token = useSelector((state) => state.auth.token);

  const orgRoleId = useSelector((state) => state.auth.orgRoleId);

  const { data, error } = useGetInvestorOverviewSummary(token, orgRoleId);

  if (error) {
    toast.error(error.message);
  }

  return (
    <>
      <div className="graphAmtSec">
        <div className="graphAmtDiv">
          <div className="graphInner">
            <>
              <div className="graphAmtDivInn">
                <h5 className="graphPoint">Available Cash Balance</h5>
                <p className="graphNum">
                  {data &&
                    formatNumbersWithThousandSeperators(data.cashBalance, true)}
                </p>
              </div>
              <div className="graphAmtDivInn">
                <h5 className="graphPoint">Active Note Count</h5>
                <p className="graphNum">{data?.activeNoteCount}</p>
              </div>
              <div className="graphAmtDivInn">
                <h5 className="graphPoint">Closed Note Count</h5>
                <p className="graphNum">{data?.closedNoteCount}</p>
              </div>
            </>
          </div>
        </div>

        <div className="graphAmtDiv">
          <div className="graphInner">
            <>
              <div className="graphAmtDivInn">
                <h5 className="graphPoint">Total Principal (Invested)</h5>
                <p className="graphNum">
                  {data &&
                    formatNumbersWithThousandSeperators(
                      data.totalInvestedPrincipal,
                      true
                    )}
                </p>
              </div>
              <div className="graphAmtDivInn">
                <h5 className="graphPoint mb-4">Total Principal (Repaid)</h5>
                <p className="graphNum">
                  {data &&
                    formatNumbersWithThousandSeperators(
                      data.totalRepaidPrincipal,
                      true
                    )}
                </p>
              </div>
              <div className="graphAmtDivInn">
                <h5 className="graphPoint">Total Principal (Outstanding)</h5>
                <p className="graphNum">
                  {data &&
                    formatNumbersWithThousandSeperators(
                      data.outstandingPrincipal,
                      true
                    )}
                </p>
              </div>
            </>
          </div>
        </div>
        <div className="graphAmtDiv">
          <div className="graphInner">
            <>
              <div className="graphAmtDivInn">
                <h5 className="graphPoint">Total Net Interest (Expected)</h5>
                <p className="graphNum">
                  {data &&
                    formatNumbersWithThousandSeperators(
                      data.totalExpectedInterest,
                      true
                    )}
                </p>
              </div>
              <div className="graphAmtDivInn">
                <h5 className="graphPoint mb-4">Total Net Interest (Repaid)</h5>
                <p className="graphNum">
                  {data &&
                    formatNumbersWithThousandSeperators(
                      data.totalRepaidInterest,
                      true
                    )}
                </p>
              </div>
              <div className="graphAmtDivInn">
                <h5 className="graphPoint">Total Net Interest (Outstanding)</h5>
                <p className="graphNum">
                  {data &&
                    formatNumbersWithThousandSeperators(
                      data.outstandingInterest,
                      true
                    )}
                </p>
              </div>
            </>
          </div>
        </div>
      </div>
    </>
  );
};

export default GraphAmountSec;
